import { useQuery } from '@tanstack/react-query';
import { GlobalAlertRequests } from 'src/requests/global-alert';

export const useGlobalAlertQuery = () => {
  const queryKey = ['global-alerts'];

  const {
    data: alerts,
    isFetching,
    refetch,
  } = useQuery({
    queryKey,
    queryFn: () => GlobalAlertRequests.getGlobalAlert(),
    refetchOnWindowFocus: false,
    initialData: [],
    retry: false, // Temporary until backend is up
  });

  return {
    alerts,
    isFetching,
    refetch,
  };
};
